import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LocalitiAuthService } from '../localiti-auth.service';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss']
})
export class WelcomeComponent implements OnInit {

  constructor(private router: Router, private auth: LocalitiAuthService) { }

  async ngOnInit() {
    if ((await this.auth.isRetailer)) {
      this.router.navigate(['/dashboard']);
    } else if ((await this.auth.isClient)) {
      this.router.navigate(['/approval']);
    } else if ((await this.auth.isLoggedIn)) {
      this.router.navigate(['/signup']);
    } else {
      this.router.navigate(['/login']);
    }
  }

}
